module.exports = __webpack_public_path__ + "static/img/package.2dbe1bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memes/package.jpg
// module id = +1Pd
// module chunks = 1